import { AutogenModelZipzone, AutogenRowZipzone } from "./autogen/AutogenModelZipzone";

export class ModelZipzone extends AutogenModelZipzone<RowZipzone> {
	constructor() {
		super(RowZipzone);
	}
}

export class RowZipzone extends AutogenRowZipzone {
}